export const CART_URL = 'https://ebookpoint.shop/cart/50645742387452:1';

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/kBT5kPw3yeRExqsgXPEiP2/ChatGPT_Image_Jul_24,_2026,_04_58_23_PM.png';

export const BG_FIELD =
  'https://cdn.magicpatterns.com/patterns/generated-images/14d4d3a9-8d30-45f2-82b7-6650aa87e05a.jpg';

export const GMAIL_REVIEWS = [
  'https://cdn.magicpatterns.com/patterns/generated-images/b05f89f2-b7a7-41be-ba88-565271a63e7e.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/74f561ef-0b8e-4fa8-9957-ae1a5dc5a58a.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/080618b6-4f3f-412e-aae2-7c3ed681389b.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/3e1aff6a-f492-4de3-9e68-4cf718216f47.jpg',
];

export const CONTENT_PREVIEWS = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/6kzxTStcdspBwFq75n5Q5z/Screenshot_2026-07-25_at_7.56.39_PM.png',
    alt: 'Ejercicio de precisión de golpe a target de pared',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3B5Np8yUoXH6AV34kCN5Vu/Screenshot_2026-07-25_at_7.57.18_PM.png',
    alt: 'Jugada de desvío corto y deflexión lateral',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gfEsSPYBYAUe5DnTrVU9Yj/Screenshot_2026-07-25_at_7.57.45_PM.png',
    alt: 'Jugada de ruptura de patrón contra rivales',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wpt9z2Th4NB82QExRrKmLv/Screenshot_2026-07-25_at_7.58.05_PM.png',
    alt: 'Sistema 3-4-3: ventajas y riesgos',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mBd4G61Ywn9q6MPhDpqATL/Screenshot_2026-07-25_at_7.58.41_PM.png',
    alt: 'Seis drills de despeje repetido',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3UvKMkHsGJ2HQbFBpw7dqp/Screenshot_2026-07-25_at_7.58.51_PM.png',
    alt: 'Posicionamiento y achique de ángulos para porteras',
  },
];

export function goToCart() {
  window.location.href = CART_URL;
}

export function scrollToCheckout() {
  const el = document.getElementById('checkout');
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

export interface TomoItem {
  emoji: string;
  title: string;
  points: string[];
}

export const TOMOS: TomoItem[] = [
  {
    emoji: '🏑',
    title: 'Tomo 1 — Fundamentos Técnicos',
    points: [
      '1.1 Grip y control de stick',
      '1.2 Conducción y cambios de dirección',
      '1.3 Pase: corto, largo, aéreo',
      '1.4 Recepción bajo presión',
      '1.5 Tackle y anti-tackle',
      '1.6 Errores técnicos por categoría de edad',
    ],
  },
  {
    emoji: '🧠',
    title: 'Tomo 2 — Táctica Individual y Colectiva',
    points: [
      '2.1 Lectura de juego 1v1',
      '2.2 Sistemas de juego (4-3-3, 3-4-3, 3-3-4)',
      '2.3 Transiciones ataque-defensa',
      '2.4 Corners cortos: ejecución y defensa',
      '2.5 Corners largos y saques de banda',
      '2.6 Lectura de rivales y ajustes en caliente',
    ],
  },
  {
    emoji: '💪',
    title: 'Tomo 3 — Preparación Física Específica',
    points: [
      '3.1 Perfil físico del jugador de hockey',
      '3.2 Velocidad y aceleración multidireccional',
      '3.3 Potencia de tren inferior',
      '3.4 Core y estabilidad lumbar',
      '3.5 Resistencia intermitente',
      '3.6 Periodización por macrociclo de temporada',
    ],
  },
  {
    emoji: '🩹',
    title: 'Tomo 4 — Prevención de Lesiones',
    points: [
      '4.1 Mapa de lesiones típicas',
      '4.2 Calentamiento activo pre-partido',
      '4.3 Fortalecimiento excéntrico de isquiotibiales',
      '4.4 Salud lumbar',
      '4.5 Return to play post-lesión',
      '4.6 Protocolo pre-temporada',
    ],
  },
  {
    emoji: '🧤',
    title: 'Tomo 5 — Portero: Sistema Completo',
    points: [
      '5.1 Biomecánica del despeje',
      '5.2 Posicionamiento y achique de ángulos',
      '5.3 Reflejos y trabajo de reacción',
      '5.4 Defensa de corner corto',
      '5.5 Preparación física específica del arquero',
      '5.6 Psicología del puesto',
    ],
  },
  {
    emoji: '🏆',
    title: 'Tomo 6 — Rendimiento y Mentalidad Competitiva',
    points: [
      '6.1 Nutrición aplicada a esfuerzo intermitente',
      '6.2 Hidratación y recuperación post-partido',
      '6.3 Sueño y supercompensación',
      '6.4 Manejo de presión en corners y penales',
      '6.5 Rutinas pre-competitivas',
      '6.6 Liderazgo dentro del campo',
    ],
  },
];

export interface BonusItem {
  emoji: string;
  title: string;
  desc: string;
  preview?: string;
}

export const BONUSES: BonusItem[] = [
  {
    emoji: '📅',
    title: 'Bono 1 — Planificador de 3 Meses por Nivel',
    desc: 'Planilla Excel con volumen, intensidad y RPE calculados para iniciación, intermedio y competitivo.',
    preview: 'https://cdn.magicpatterns.com/uploads/4w66zheJpcJaMuu1GYLx4z/ChatGPT_Image_Jul_25,_2026,_07_20_35_PM.png',
  },
  {
    emoji: '⚡',
    title: 'Bono 2 — Las Bases de la Velocidad en Hockey',
    desc: 'Programa progresivo de 6 semanas: fases de la velocidad, aceleración y frenado.',
    preview: 'https://cdn.magicpatterns.com/uploads/7A6vSWADdRwtK6qYKb8ikv/ChatGPT_Image_Jul_25,_2026,_07_20_40_PM.png',
  },
  {
    emoji: '📐',
    title: 'Bono 3 — Playbook de Corners Cortos',
    desc: '10 jugadas ofensivas y 6 estructuras defensivas listas para entrenar.',
    preview: 'https://cdn.magicpatterns.com/uploads/k4ptuWgDSBYQhR2KVgBvcr/ChatGPT_Image_Jul_25,_2026,_07_20_41_PM.png',
  },
  {
    emoji: '📔',
    title: 'Bono 4 — Mi Diario de Carga y Prevención',
    desc: 'Registro de RPE diario con semáforo de alerta para evitar sobrecargas.',
    preview: 'https://cdn.magicpatterns.com/uploads/iNRKm23ViD68Lds5Q7MMhb/ChatGPT_Image_Jul_25,_2026,_07_20_43_PM.png',
  },
  {
    emoji: '🥗',
    title: 'Bono 5 — Guía de Nutrición Pre/Post Partido',
    desc: 'Menús según horario de partido, estrategia durante el juego y lista de compra semanal.',
    preview: 'https://cdn.magicpatterns.com/uploads/p7JZVeAPcuwdZS7XnQJkNJ/ChatGPT_Image_Jul_25,_2026,_07_20_44_PM.png',
  },
  {
    emoji: '💧',
    title: 'Bono 6 — Calculadora de Proteínas e Hidratación',
    desc: 'Proteína y agua según tu peso, con ajuste automático para días de partido.',
    preview: 'https://cdn.magicpatterns.com/uploads/d1ay8CRoK4ifDBHaDMg3kw/ChatGPT_Image_Jul_25,_2026,_07_23_26_PM.png',
  },
  {
    emoji: '🎯',
    title: 'Bono 7 — Guía de Autoentrenamiento Individual',
    desc: 'Qué entrenar sola, con una compañera o en el club. Progresión de 12 semanas.',
    preview: 'https://cdn.magicpatterns.com/uploads/8aKLsv9rJJGa6nDd4RzDX8/ChatGPT_Image_Jul_25,_2026,_07_23_28_PM.png',
  },
  {
    emoji: '📊',
    title: 'Bono 8 — Batería de Tests de Evaluación Física',
    desc: '6 tests físicos con protocolo completo y planilla de seguimiento por fecha.',
    preview: 'https://cdn.magicpatterns.com/uploads/2ngezYvDjwnAamnh2iihSt/ChatGPT_Image_Jul_25,_2026,_07_23_29_PM.png',
  },
  {
    emoji: '💬',
    title: 'Bono 9 — Kit de Comunicación y Mensajes Listos',
    desc: 'Mensajes prácticos para entrenamientos, cambios de horario, post-partido, faltas y familias.',
    preview: 'https://cdn.magicpatterns.com/uploads/8XC1UX2fivautk3ExSbyEx/ChatGPT_Image_Jul_25,_2026,_07_23_29_PM_(1).png',
  },
];

export const PROBLEMS = [
  'Corres todo el partido pero llegas fundida al último cuarto y bajas tu nivel justo cuando más importa.',
  'Sabes lo que tienes que hacer en tu posición, pero bajo presión el rival te gana la espalda una y otra vez.',
  'Los corners cortos son una lotería: no tienes jugadas claras ni sabes cómo defenderlos.',
  'Las molestias en isquios y espalda te frenan y no sabes cómo prevenir esas lesiones típicas del hockey.',
  'Entrenas mucho pero sin un plan real: no ves progreso y no sabes si estás mejorando de verdad.',
];

export interface Testimonial {
  name: string;
  detail: string;
  text: string;
}

export const TESTIMONIALS: Testimonial[] = [
  { name: 'Marta Sáez', detail: '19 años · Madrid', text: 'Llevo dos años estancada en el club y en un mes noté más piernas y más cabeza en el campo. El planificador es una pasada.' },
  { name: 'Lucía Herrero', detail: '22 años · Barcelona', text: 'Soy media y las transiciones ataque-defensa por fin me hicieron clic. Mi entrenador me subió al primer equipo.' },
  { name: 'Nerea Campos', detail: '17 años · Valencia', text: 'La guía de prevención me quitó las molestias de isquios que arrastraba desde el verano. Vale cada euro.' },
  { name: 'Alba Molina', detail: '24 años · Sevilla', text: 'Portera aquí. El tomo 5 es lo más completo que he visto sobre el puesto en español. Achique y corners TOP.' },
  { name: 'Paula Reyes', detail: '20 años · San Sebastián', text: 'Los tests físicos me dieron datos reales de dónde estaba floja. En 12 semanas mejoré mi sprint un montón.' },
];

export const OBJECTIONS = [
  { q: '¿Sirve si soy principiante?', a: 'Sí. El Tomo 1 arranca desde los fundamentos técnicos y el sistema tiene rutas para iniciación, intermedio y competitivo. Vas a tu ritmo.' },
  { q: '¿Y si juego en una posición específica?', a: 'Hay contenido específico por posición, incluido un tomo completo solo para porteras, más sistemas de juego para líneas de ataque, medio y defensa.' },
  { q: '¿Cómo recibo el material?', a: 'Es 100% PDF + planillas Excel. Lo recibes al instante en tu correo tras la compra. Pago único, sin suscripciones.' },
  { q: '¿Necesito equipamiento especial?', a: 'No. Está pensado para entrenar sola, con una compañera o en el club, con el material que ya tienes.' },
  { q: '¿Puedo aplicarlo desde hoy?', a: 'Sí. Las planillas y calculadoras están listas para usar y las jugadas de corner puedes llevarlas a tu próximo entrenamiento.' },
];

export const SPANISH_NAMES = [
  'Laura G.', 'María T.', 'Carla R.', 'Sara V.', 'Marta S.', 'Lucía H.',
  'Nerea C.', 'Alba M.', 'Paula R.', 'Andrea L.', 'Claudia F.', 'Elena P.',
  'Irene D.', 'Rocío N.', 'Ainhoa B.',
];

export const SPANISH_CITIES = [
  'Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Terrassa', 'San Sebastián',
  'Bilbao', 'Zaragoza', 'Málaga', 'A Coruña', 'Vitoria', 'Pamplona',
  'Granada', 'Alicante', 'Santander',
];
